import {PaginatedRequest} from "@/models/pagination";
import { RateGroupType } from "@/constants/rate-group-type";

export interface RateGroup {
    id: number;
    name?: string;
    type?: RateGroupType;
    isActive: boolean;
    description?: string;
    linkedRelationsCount?: number;
}

export const DefaultRateGroupModel = () => {
    return {
        id: 0,
        name: '',
        type: RateGroupType.SalesRate,
        isActive: false,
    } as RateGroup;
}

export interface RateGroupListRequest extends PaginatedRequest {
    name?: string;
    type?: RateGroupType;
    includeActive?: boolean;
    includeArchived?: boolean;
}

export interface ListRelationsOfRateGroupRequest extends PaginatedRequest {
    rateGroupId: number;
    relationName: string;
}

export interface ListRelationsOfRateGroupModel {
    relationId: number;
    relationName: string;
    coupledAt: number;
}
